import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-068f8f10"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["href"];
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "product-anchor"
}, null, -1));
const _hoisted_3 = {
  class: "catalog-page product-page"
};
const _hoisted_4 = {
  key: 0,
  class: "page-title"
};
const _hoisted_5 = {
  class: "el-card carousel-card"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-image__error"
}, "Preview not available", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");
  const _component_product_map = _resolveComponent("product-map");
  const _component_zero_size_placeholder = _resolveComponent("zero-size-placeholder");
  const _component_el_carousel = _resolveComponent("el-carousel");
  const _component_el_col = _resolveComponent("el-col");
  const _component_details_section = _resolveComponent("details-section");
  const _component_el_row = _resolveComponent("el-row");
  const _component_product_table = _resolveComponent("product-table");
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.canonicalUrl ? (_openBlock(), _createBlock(_Teleport, {
    key: 0,
    to: "head"
  }, [_createElementVNode("link", {
    rel: "canonical",
    href: `https://shop.geospatial.com/${_ctx.canonicalUrl}`
  }, null, 8, _hoisted_1)])) : _createCommentVNode("", true), _hoisted_2, _createElementVNode("div", _hoisted_3, [_ctx.title ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.title), 1)) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    gutter: 12,
    style: {
      "justify-content": "space-evenly"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      lg: 12,
      md: 12,
      sm: 24
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_carousel, {
        height: "600px",
        autoplay: false,
        "indicator-position": !_ctx.product?.thumbnail ? 'none' : 'inside',
        arrow: "never"
      }, {
        default: _withCtx(() => [_ctx.product?.thumbnail ? (_openBlock(), _createBlock(_component_el_carousel_item, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_image, {
            src: _ctx.thumbnail,
            onContextmenu: _withModifiers(_ctx.openCopyrightAlert, ["prevent"]),
            fit: "contain",
            style: {
              "height": "100%",
              "width": "100%"
            }
          }, {
            error: _withCtx(() => [_hoisted_6]),
            _: 1
          }, 8, ["src", "onContextmenu"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_carousel_item, {
          class: "dynamic-map-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_zero_size_placeholder, null, {
            default: _withCtx(() => [_createVNode(_component_product_map, {
              publicationGid: _ctx.publication.gid,
              "product-gid": _ctx.product.gid,
              bounds: _ctx.bounds,
              current: _ctx.product?.gid,
              "onFeature:clicked": _ctx.viewDetails
            }, null, 8, ["publicationGid", "product-gid", "bounds", "current", "onFeature:clicked"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["indicator-position"])])]),
      _: 1
    }), _createVNode(_component_el_col, {
      lg: 12,
      md: 12,
      sm: 24,
      class: "details-container"
    }, {
      default: _withCtx(() => [_createElementVNode("h2", null, _toDisplayString(_ctx.product.gid ? "Sheet" : "Series") + " Details", 1), _createVNode(_component_details_section, {
        publication: _ctx.publication,
        publisher: _ctx.publisher,
        product: _ctx.product
      }, null, 8, ["publication", "publisher", "product"])]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("div", null, [_createVNode(_component_product_table, {
    publication: _ctx.publication,
    "product-sku": _ctx.product.sku,
    columns: _ctx.columns,
    total: _ctx.publication.itemCount || 0,
    "onProduct:selected": _ctx.viewDetails
  }, null, 8, ["publication", "product-sku", "columns", "total", "onProduct:selected"])])])], 64);
}